/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  HTTPValidationError,
  ProjectDTO,
  ProjectMembersOut,
  SetPrimaryEditorDTO,
} from '../fastAPI.schemas'

/**
 * Every member of the organisation owning this project.

Access is already settled by ``project_access_dependency``: a caller who is
not a member of that organisation never reaches this.
 * @summary Get Project Members
 */
export const getProjectMembers = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<ProjectMembersOut>({
    url: `/projects/${projectGuid}/members`,
    method: 'GET',
    signal,
  })
}

export const getGetProjectMembersQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/members`] as const
}

export const getGetProjectMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectMembers>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectMembers>>, TError, TData>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProjectMembersQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectMembers>>> = ({ signal }) =>
    getProjectMembers(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectMembers>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetProjectMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectMembers>>
>
export type GetProjectMembersQueryError = HTTPValidationError

/**
 * @summary Get Project Members
 */

export function useGetProjectMembers<
  TData = Awaited<ReturnType<typeof getProjectMembers>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectMembers>>, TError, TData>
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectMembersQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Change the Primärbearbeiter -- admins of the owning organisation only
(R12).

Kept off the general project update: that one is open to every member, and
who a project is assigned to is not theirs to change.
 * @summary Set Primary Editor
 */
export const setPrimaryEditor = (projectGuid: string, setPrimaryEditorDTO: SetPrimaryEditorDTO) => {
  return customInstance<ProjectDTO>({
    url: `/projects/${projectGuid}/primary-editor`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setPrimaryEditorDTO,
  })
}

export const useSetPrimaryEditorMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPrimaryEditor>>,
    TError,
    { projectGuid: string; data: SetPrimaryEditorDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof setPrimaryEditor>>,
  TError,
  { projectGuid: string; data: SetPrimaryEditorDTO },
  TContext
> => {
  const mutationKey = ['setPrimaryEditor']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setPrimaryEditor>>,
    { projectGuid: string; data: SetPrimaryEditorDTO }
  > = props => {
    const { projectGuid, data } = props ?? {}

    return setPrimaryEditor(projectGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/primary-editor` },
    {
      operationId: 'set_primary_editor_projects__project_guid__primary_editor_put',
      operationName: 'setPrimaryEditor',
    },
  )

  return customOptions
}

export type SetPrimaryEditorMutationResult = NonNullable<
  Awaited<ReturnType<typeof setPrimaryEditor>>
>
export type SetPrimaryEditorMutationBody = SetPrimaryEditorDTO
export type SetPrimaryEditorMutationError = HTTPValidationError

/**
 * @summary Set Primary Editor
 */
export const useSetPrimaryEditor = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPrimaryEditor>>,
    TError,
    { projectGuid: string; data: SetPrimaryEditorDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof setPrimaryEditor>>,
  TError,
  { projectGuid: string; data: SetPrimaryEditorDTO },
  TContext
> => {
  const mutationOptions = useSetPrimaryEditorMutationOptions(options)

  return useMutation(mutationOptions)
}
